import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { DollarSign, TrendingUp, Shield, Star } from 'lucide-react';
export function Slide8_Investment() {
  return <SlideLayout data-id="element-293">
      <div className="flex flex-col h-full justify-center space-y-12 sm:space-y-16" data-id="element-294">
        <div className="space-y-6 text-center" data-id="element-295">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-296">
            Partnership Structure
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-297">
            Pricing reflects ownership and accountability — not effort or hours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto w-full" data-id="element-298">
          {/* Build */}
          <motion.div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-299">
            <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-6 border border-slate-700" data-id="element-300">
              <Shield className="w-6 h-6 text-emerald-400" data-id="element-301" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-302">Build</h3>
            <p className="text-slate-400 text-sm mb-6" data-id="element-303">One-time setup</p>
            <p className="text-slate-500 text-sm" data-id="element-304">
              System architecture and initial setup
            </p>
          </motion.div>

          {/* System */}
          <motion.div className="bg-slate-900/40 border border-emerald-500/30 rounded-xl p-8 relative" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} data-id="element-305">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500 rounded-t-xl" data-id="element-306" />
            <div className="w-12 h-12 rounded-full bg-emerald-500/10 flex items-center justify-center mb-6 border border-emerald-500/20" data-id="element-307">
              <DollarSign className="w-6 h-6 text-emerald-400" data-id="element-308" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-309">System</h3>
            <p className="text-emerald-400 text-sm mb-6" data-id="element-310">Monthly recurring</p>
            <p className="text-slate-500 text-sm" data-id="element-311">Per month + campaign costs</p>
          </motion.div>

          {/* Performance */}
          <motion.div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-312">
            <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-6 border border-slate-700" data-id="element-313">
              <TrendingUp className="w-6 h-6 text-amber-400" data-id="element-314" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-315">Performance</h3>
            <p className="text-slate-400 text-sm mb-6" data-id="element-316">Success-based</p>
            <p className="text-slate-500 text-sm" data-id="element-317">
              Per rep at 30/60/90 day milestones
            </p>
          </motion.div>
        </div>

        <div className="space-y-8" data-id="element-318">
          <div className="bg-emerald-500/5 border border-emerald-500/20 rounded-xl p-6 max-w-3xl mx-auto" data-id="element-319">
            <p className="text-emerald-400 text-center font-medium" data-id="element-320">
              Performance bonuses align our success with yours. We only win when
              your reps succeed.
            </p>
          </div>

          {/* Guarantees */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-321">
            <div className="flex items-center space-x-2 px-6 py-3 rounded-full bg-amber-500/10 border border-amber-500/30" data-id="element-322">
              <Star className="w-5 h-5 text-amber-400" fill="currentColor" data-id="element-323" />
              <span className="text-amber-400 font-medium" data-id="element-324">
                Money-Back Guaranteed
              </span>
            </div>
            <div className="flex items-center space-x-2 px-6 py-3 rounded-full bg-amber-500/10 border border-amber-500/30" data-id="element-325">
              <Star className="w-5 h-5 text-amber-400" fill="currentColor" data-id="element-326" />
              <span className="text-amber-400 font-medium" data-id="element-327">
                Month-to-Month Agreement
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </SlideLayout>;
}